var _rect, _rect2, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInpersonHappening(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 575,
    height: 324,
    viewBox: "0 0 575 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 575,
    height: 324,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 575,
    height: 324,
    rx: 10,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 575,
    height: 324,
    rx: 10,
    fill: "url(#paint0_radial_2397_18020)",
    fillOpacity: 0.5,
    style: {
      mixBlendMode: "multiply"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.007 148.029C302.406 148.029 306.123 144.132 306.123 139.089C306.123 134.167 302.386 130.391 298.007 130.391C293.647 130.391 289.891 134.228 289.911 139.129C289.911 144.132 293.607 148.029 298.007 148.029ZM274.784 148.491C278.621 148.491 281.855 145.076 281.855 140.696C281.855 136.397 278.58 133.123 274.784 133.123C270.987 133.123 267.712 136.458 267.732 140.737C267.732 145.076 270.967 148.491 274.784 148.491ZM263.714 166.732H278.781C276.632 163.658 278.942 157.592 283.482 154.016C281.272 152.589 278.4 151.545 274.784 151.545C265.804 151.545 259.998 158.154 259.998 163.598C259.998 165.587 261.002 166.732 263.714 166.732ZM285.491 166.712H310.522C313.837 166.712 314.982 165.708 314.982 163.859C314.982 158.696 308.413 151.585 298.007 151.585C287.58 151.585 281.031 158.696 281.031 163.859C281.031 165.708 282.176 166.712 285.491 166.712Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2397_18020)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 286.558L99.5646 274.058C137.554 261.557 214.683 236.557 291.237 257.391C367.79 278.224 417.844 312.969 521.473 312.969C625.102 312.969 675.156 286.558 713.145 274.057L751.71 223L751.71 461.559L713.145 461.559C675.156 461.559 598.027 461.559 521.473 461.559C444.92 461.559 367.79 461.559 291.237 461.559C214.683 461.559 137.554 461.559 99.5646 461.559L61 461.559L61 286.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M675.71 292.558L637.145 280.058C599.156 267.557 522.027 242.557 445.473 263.391C368.92 284.224 318.866 318.969 215.237 318.969C111.607 318.969 61.5538 292.558 23.5647 280.058L-14.9999 229L-15 467.559L23.5647 467.559C61.5538 467.559 138.683 467.559 215.237 467.559C291.79 467.559 368.92 467.559 445.473 467.559C522.027 467.559 599.156 467.559 637.145 467.559L675.71 467.559L675.71 292.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-25 292.558L13.5845 280.058C51.593 267.557 128.762 242.557 205.355 263.391C281.948 284.224 332.027 318.969 435.71 318.969C539.392 318.969 589.472 292.558 627.48 280.057L666.065 229L666.065 467.559L627.48 467.559C589.472 467.559 512.303 467.559 435.71 467.559C359.117 467.559 281.948 467.559 205.355 467.559C128.762 467.559 51.593 467.559 13.5845 467.559L-25 467.559L-25 292.558Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2397_18020",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.5 149.5) rotate(29.6711) scale(288.877 512.668)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B40ED",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B40ED"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2397_18020"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 181H575V314C575 319.523 570.523 324 565 324H10C4.47716 324 0 319.523 0 314V181Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInpersonHappening);
export default __webpack_public_path__ + "static/media/inperson-happening.904ad01e793160747a4a57d7483efdfc.svg";
export { ForwardRef as ReactComponent };